import { VersionSectionConfig } from "../models/VersionSectionConfig";

export const AppDriverConfig: VersionSectionConfig = {
    packageName: 'com.edtsoft.t_llevodriver'
}